export const PLATFORM_ENVS = ["dev", "qa", "staging", "prod"] as const;
export type PlatformEnv = (typeof PLATFORM_ENVS)[number];

const normalizePlatformEnv = (rawEnv?: string): PlatformEnv => {
  const normalized = (rawEnv ?? "dev").toLowerCase();
  if (normalized === "stage") return "staging";
  if (PLATFORM_ENVS.includes(normalized as PlatformEnv)) {
    return normalized as PlatformEnv;
  }
  return "dev";
};

export const env = normalizePlatformEnv(
  process.env.NEXT_PUBLIC_WRANGO_PLATFORM_ENV,
);
